import {makeMain as sentryMakeMain} from '@sentry/browser';

import type {SentryHub} from 'src/internal/errors/sentry/types';

export default function makeMain(hub: SentryHub): void {
  sentryMakeMain(hub);
}
